import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/inventory'
import Component from 'components/Inventory/Select'

export default createListModalContainer({ actions })(Component)
